module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/duplex-browser.js
// module id = 439
// module chunks = 1 5 6 7 9 10 11 13 15 16 22 23 25 29 30 59